import { render, staticRenderFns } from "./BuyoutReportDetail.vue?vue&type=template&id=67e7ebe0"
import script from "./BuyoutReportDetail.vue?vue&type=script&lang=js"
export * from "./BuyoutReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports